// extracted by mini-css-extract-plugin
export default {"uploadArea":"uploadArea_uploadArea__E3c0S","draggingOver":"uploadArea_draggingOver__LvrCq","removeFile":"uploadArea_removeFile__ao8bl"};